import keyManager from 'constant-manager'

export default keyManager(
  {
    SET: '',
  },
  { prefix: 'CHALLENGE__' },
)

export interface IChallenge {
  id: string
  name: string
  customPrize: string
  repeat: boolean
  startDate: string
  timezone: string
  duration: number
}
